// src/store/routeReplaySlice.js
import { createSlice } from "@reduxjs/toolkit";
import { journey } from "config/apis";

const initialState = {
  journeyPlot: [],
  journey: [],
  devices: [],
  currentPacket: {},
  progress: 0,
  haltData: [],
  ignitionData: [],
  sosMarkers: [],
  rFIDData: [],
  highlightSegment: null,
};

const routeReplaySlice = createSlice({
  name: "routeReplay",
  initialState,
  reducers: {
    setRouteReplayData: (state, action) => {
      state.devices = action.payload;

      // Agar payload mein devices object hai
      if (action.payload && action.payload.devices) {
        const allDevices = action.payload.devices;

        // Filtering logic: Jiska Raw_type ya ALERT_TYPE "1" hai
        // Note: Aapke JSON mein "ALERT_TYPE" dikh raha hai, 
        // agar property ka naam "Raw_type" hai toh bas niche use change kar dein.
        state.sosMarkers = Object.values(allDevices)
          .filter(device => device.raw && device.raw.ALERT_TYPE === "1")
          .map(device => ({
            latitude: device.location.latitude,
            longitude: device.location.longitude,
            timestamp: device.updatedAt,
            ...device.raw
          }));

        console.log("SOS MARKERS STATE:", state.sosMarkers);
      }
    },
    setHaltData: (state, action) => {
      state.haltData = action.payload;
    },
    // 2. Ignition Data update karne ke liye
    setIgnitionData: (state, action) => {
      state.ignitionData = action.payload;
    },
    setHighlightSegment: (state, action) => {
      state.highlightSegment = action.payload;
    },
    setRFIDData: (state, action) => {
      state.rFIDData = action.payload;
    },
    addOrUpdateDevice: (state, action) => {
      const { timestamp, deviceData } = action.payload;
      state.devices[timestamp] = deviceData;
    },
    clearHighlightSegment: (state) => {
      state.highlightSegment = null;
    },
    clearRouteReplayData: (state) => {
      state.devices = [];
      state.haltData = [];
      state.ignitionData = [];
      state.rFIDData = [];
      state.sosMarkers = [];
    },
    setRouteCurrentPacket: (state, action) => {
      state.currentPacket = action.payload;
    },
    clearRouteCurrentPacket: (state) => {
      state.currentPacket = {};
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    clearProgress: (state) => {
      state.progress = 0;
    },
    setJourneyPlotData: (state, action) => {
      state.journey = action.payload;
    },
    clearJourneyPlotData: (state) => {
      state.journey = [];
    },
    setSelectedJourneyPlotData: (state, action) => {
      state.journeyPlot = action.payload;
    },
    clearSeletectedJourneyPlotData: (state) => {
      state.journeyPlot = [];
    },
  },
});

export const {
  setRouteReplayData,
  addOrUpdateDevice,
  clearRouteReplayData,
  setRouteCurrentPacket,
  clearRouteCurrentPacket,
  clearHighlightSegment,
  setHighlightSegment,
  setProgress,
  setHaltData,        // Export this
  setRFIDData,        // Export this
  setIgnitionData,
  clearProgress,
  setJourneyPlotData,
  clearJourneyPlotData,
  setSelectedJourneyPlotData,
  clearSeletectedJourneyPlotData,
} = routeReplaySlice.actions;

export default routeReplaySlice.reducer;
